import {
  getUserSelector,
  userIsLoggedInSelector,
} from "@/redux/user/userSlice";
import { ReactNode } from "react";
import { useSelector } from "react-redux";

import { ObjectivesLandingPage } from "./ObjectivesLandingPage";

/**
 * Objectives is waitlist-only. Everyone without `grantedAccess.objectives`
 * gets the landing page, and none of the Objectives code runs for them.
 */
export const ObjectivesAccessGate = ({ children }: { children: ReactNode }) => {
  const loggedIn = useSelector(userIsLoggedInSelector);
  const { user, status } = useSelector(getUserSelector);

  if (!loggedIn) return <ObjectivesLandingPage />;
  // A stored token but no profile yet: wait rather than flash the landing page.
  if (!user.uuid && status !== "rejected") return null;
  if (!user.grantedAccess?.objectives) return <ObjectivesLandingPage />;
  return children;
};
